import { ETypeSearchItem } from '@enums/TypeSearchItem';
import HttpClientError from '@errors/HttpClientError';
import { type SearchItem } from '@models/SearchItem';
import HttpClient from '@services/utils/HttpClient';

import { type IFindInputData } from './dtos/find/InputData';
import { type IFindOutputData } from './dtos/find/OutputData';
import { type ISearchRepository } from './ISearchRepository';

interface IFindParams {
  q: string;
}

interface IFindResponse {
  lista: {
    conteudo: string;
    id: number;
    liberado: boolean;
    tipo: ETypeSearchItem;
  }[];
}

const words = [
  'o',
  'a',
  'os',
  'as',
  'um',
  'uma',
  'uns',
  'umas',
  'de',
  'do',
  'da',
  'dos',
  'das',
  'em',
  'no',
  'na',
  'nos',
  'nas',
  'com',
  'por',
  'para',
  'pelo',
  'pela',
  'pelos',
  'pelas',
  'sobre',
  'entre',
  'até',
  'após',
  'perante',
  'contra',
  'sob',
  'segundo',
  'durante',
  'e',
  'ou',
  'mas',
  'que',
  'como',
  'porque',
  'portanto',
  'se',
  'quando',
  'embora',
  'enquanto',
  'onde',
  'caso',
  'este',
  'esta',
  'estes',
  'estas',
  'aquele',
  'aquela',
  'aquilo',
  'qual',
  'quais',
  'cujo',
  'cuja',
  'seja',
  'são',
  'foi',
  'está',
  'estar',
  'foram',
  'era',
  'eram',
  'há',
  'tem',
  'têm',
  'também',
  'ainda',
  'já',
  'muito',
  'mais',
  'menos',
  'cada',
  'tudo',
  'todos',
  'todas',
];

class SearchService implements ISearchRepository {
  public async find(inputData: IFindInputData): Promise<IFindOutputData> {
    try {
      const regex = new RegExp(`\\b(${words.join('|')})\\b`, 'gi');
      const text = inputData.text
        .replace(regex, '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!text) {
        const output: IFindOutputData = {
          list: [],
        };
        return output;
      }
      const response = await HttpClient.get<IFindResponse, IFindParams>({
        path: 'busca.php',
        params: {
          q: text,
        },
      });
      const existingItems = new Set();
      const uniqueItems = response.data.lista.filter((item) => {
        const key = `${item.id}-${item.tipo}`;
        if (existingItems.has(key)) {
          return false;
        }
        existingItems.add(key);
        return true;
      });
      const output: IFindOutputData = {
        list: uniqueItems.map((item, index) => {
          const splitContent = item!.conteudo.split('<br>');
          const searchItem: SearchItem = {
            id: item!.id,
            subtitle: splitContent[1],
            type: item!.tipo,
            title: splitContent[0]
              .replace('(Pronto Socorro)', '')
              .replace('(Pediatria)', '')
              .replace('(Enfermaria)', '')
              .replace('(Ambulatório)', '')
              .replace(' Em Uso oral', '')
              .replace(' Em Uso intravenoso', '')
              .replace(' Em Uso intramuscular / subcutâneo', '')
              .replace(' Em Uso otológico', '')
              .replace(' Em Uso tópico', '')
              .replace(' Em Uso inalatório', '')
              .replace(' Em Uso oftalmológico', '')
              .replace('(G.O.)', '')
              .replace('(G.O.)', '')
              .replace('(G.O.)', ''),
            uniqueId: index,
            isReleased: item!.liberado,
          };
          return searchItem;
        }),
      };
      return output;
    } catch (err) {
      if (err instanceof HttpClientError) {
        throw new HttpClientError({
          body: err.body,
          message: err.message,
          response: err.response,
        });
      }
      if (err instanceof Error) {
        throw new Error(err.message);
      }
      throw new Error(String(JSON.stringify(err)));
    }
  }
}

export default new SearchService();
